module.exports = __webpack_public_path__ + "static/media/13.ebf564f9.jpg";